import { Grid, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { Applicant, Broker, BrokerList } from '../../redux-store/types/api-types';
import {
  DLCLMasters,
  grossAnnualMasters,
  investorTypeCategoryMaster,
  investorTypeMasters,
  investorTypeSubCategoryMaster,
  PEPsMasters,
  USER_ROLES,
  YES_NO_MASTER,
  AOI_BOI_MASTER,
  KBOLT_XALT_MASTER,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import UseRadioGroup from '../../lib/formik/Radio';
import {
  applicationComparison,
  clearclIdField,
  cleardpIdField,
  currencyConversion,
  dlclIdFieldMandatory,
  isInvestorCategorySelected,
  isInvestorTrust,
  isSelectedGreaterThan10,
  removeSingleQuote,
  saveForLater,
  ifPushToXalt,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getBrokers, updateApplication } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { DematDetails } from '../investors/additionalKYCDetails';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import MFCheckbox from '../../lib/formik/Checkbox';
import SimpleDialog from '../commonComponents';
import { useModal } from 'mui-modal-provider';
import { showError } from '../../redux-store/actions/auth';

const contributorObject: Partial<Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  netWorth: '',
  netWorthDate: '',
  politicallyExposedPersonStatus: '',
  dlclId: dlclIdFieldMandatory() ? '' : 'none',
  dpId: '',
  clId: '',
  nameOfBroker: '',
  isAccreditedInvestor: null,
  investorTypeCategory: '',
  investorTypeSubCategory: '',
  isNPO: false,
  boiOrAop: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<Applicant>[];
  shouldClearPlan?: boolean;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  shouldClearPlan: false,
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { showModal } = useModal();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  const [accreditedInvestorDialog, setAccreditedInvestorDialog] = useState<{
    newValue: boolean;
  } | null>(null);

  useEffect(() => {
    try {
      const { applicants = [] } = application || {};
      setContributorValues({
        ...contributorValues,
        applicants: applicants.length
          ? applicants.map((applicant) => {
              return {
                ...applicant,
                dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
                nameOfBroker: applicant.nameOfBroker || '',
                isAccreditedInvestor: applicant.isAccreditedInvestor ?? null,
                investorTypeCategory: applicant.investorType
                  ? applicant.investorTypeCategory || ''
                  : '',
                investorTypeSubCategory:
                  applicant.investorTypeCategory &&
                  isInvestorCategorySelected(applicant?.investorTypeCategory || '')
                    ? applicant.investorTypeSubCategory || ''
                    : '',
                isNPO: isInvestorTrust(applicant?.investorType || '') ? applicant.isNPO : false,
                boiOrAop: applicant.boiOrAop || '',
              };
            })
          : [contributorObject],
        shouldClearPlan: false,
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [] } = values;
    const shouldClearPlan = values.shouldClearPlan;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const isaccreditedInvestorYes = applicants?.some(
      (applicant) => applicant?.isAccreditedInvestor === true
    );
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
            dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
            // isAccreditedInvestor: applicant.isAccreditedInvestor ?? null,
            isAccreditedInvestor: isaccreditedInvestorYes,
            accreditationCertificateNumber:
              applicant.isAccreditedInvestor === true
                ? applicant.accreditationCertificateNumber || ''
                : '',
            accreditationValidFrom:
              applicant.isAccreditedInvestor === true
                ? applicant.accreditationValidFrom || null
                : null,
            accreditationValidTo:
              applicant.isAccreditedInvestor === true
                ? applicant.accreditationValidTo || null
                : null,
            investorTypeCategory: applicant.investorType
              ? applicant.investorTypeCategory || ''
              : '',
            investorTypeSubCategory:
              applicant.investorTypeCategory &&
              isInvestorCategorySelected(applicant?.investorTypeCategory || '')
                ? applicant.investorTypeSubCategory || ''
                : '',
            isNPO: isInvestorTrust(applicant?.investorType || '') ? applicant.isNPO : false,
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
        ...(shouldClearPlan && {
          schemeId: null,
          planId: null,
          fundScheme: '',
          classPlan: '',
          commitmentAmount: null,
          setupFeePercentage: null,
          managementFeesRate: null,
          taxRate: null,
          drawDownNumber: null,
          contributionChequeAmount: null,
          modeOfPayment: '',
          paymentRefNo: '',
          chequeDate: null,
          paymentBankAccountNumber: '',
          paymentBankame: '',
          paymentBankAccontType: '',
          setupFeeAmount: null,
          setupFeeGST: null,
          totalSetupFee: null,
          setupFeeTDS: null,
          netSetupFeeLessTDS: null,
          totalAmountPayable: null,
          hurdleRateApplicable: '',
          hurdleRate: null,
          hurdleRateType: null,
          performanceFeeApplicable: '',
          performanceFeeType: null,
          performanceFee: null,
          exitChargeApplicable: '',
          exitChargeType: null,
          exitCharge: null,
          operatingExpenseApplicable: '',
          operatingExpenseType: null,
          operatingExpenses: null,
          distributionFee: null,
          exitLoad: null,
          exitLoadApplicable: '',
          managementFeeApplicable: null,
          managementFeeType: null,
          setupFeeApplicable: '',
          setupFeeType: null,
        }),
      }
    );

    if (id && !checkApplication) {
      const planResetPayload = shouldClearPlan
        ? {
            schemeId: null,
            planId: null,
            fundScheme: '',
            classPlan: '',
            commitmentAmount: null,
            setupFeePercentage: null,
            managementFeesRate: null,
            taxRate: null,
            drawDownNumber: null,
            contributionChequeAmount: null,
            modeOfPayment: '',
            paymentRefNo: '',
            chequeDate: null,
            paymentBankAccountNumber: '',
            paymentBankame: '',
            paymentBankAccontType: '',
            setupFeeAmount: null,
            setupFeeGST: null,
            totalSetupFee: null,
            setupFeeTDS: null,
            netSetupFeeLessTDS: null,
            totalAmountPayable: null,
            hurdleRateApplicable: '',
            hurdleRate: null,
            hurdleRateType: null,
            performanceFeeApplicable: '',
            performanceFeeType: null,
            performanceFee: null,
            exitChargeApplicable: '',
            exitChargeType: null,
            exitCharge: null,
            operatingExpenseApplicable: '',
            operatingExpenseType: null,
            operatingExpenses: null,
            distributionFee: null,
            exitLoad: null,
            exitLoadApplicable: '',
            managementFeeApplicable: null,
            managementFeeType: null,
            setupFeeApplicable: '',
            setupFeeType: null,
          }
        : {};
      await dispatch(
        updateApplication({
          body: {
            ...application,
            ...planResetPayload,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant, index) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
              nameOfBroker: cleardpIdField(applicant.dlclId || '') ? '' : applicant.nameOfBroker,
              isAccreditedInvestor: applicant.isAccreditedInvestor ?? null,
              accreditationCertificateNumber:
                applicant.isAccreditedInvestor === true
                  ? applicant.accreditationCertificateNumber || ''
                  : '',
              accreditationValidFrom:
                applicant.isAccreditedInvestor === true
                  ? applicant.accreditationValidFrom || null
                  : null,
              accreditationValidTo:
                applicant.isAccreditedInvestor === true
                  ? applicant.accreditationValidTo || null
                  : null,
              investorTypeCategory: applicant.investorType
                ? applicant.investorTypeCategory || ''
                : '',
              investorTypeSubCategory:
                applicant.investorTypeCategory &&
                isInvestorCategorySelected(applicant?.investorTypeCategory || '')
                  ? applicant.investorTypeSubCategory || ''
                  : '',
              isNPO: isInvestorTrust(applicant?.investorType || '') ? applicant.isNPO : false,
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicants[index]?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicants[index].boiOrAop
                  : '',
            })),
            modeOfHolding: 'single',
            isAccreditedInvestor: isaccreditedInvestorYes,
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      const invalidOptionChoice = values.applicants?.find((applicant) =>
        isSelectedGreaterThan10(applicant?.investorTypeSubCategory || '')
      );

      if (invalidOptionChoice) {
        const { destroy } = showModal(SimpleDialog, {
          content: 'Investment more than 10% is not allowed',
          actions: [
            {
              label: 'OK',
              onClick: () => {
                destroy();
              },
            },
          ],
        });
        return;
      }

      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      await handleApplicant(values);
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              brokerList?.broker_list as Broker[],
              application?.createdAt || '',
              ifPushToXalt(application?.pushDataTo || '')
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => {
        const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
        return (
          <>
            <Grid
              container
              rowSpacing={1}
              //columnSpacing={5}
              sx={{
                width: '100%',
                ml: 0,
                '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
              }}
              component="form"
              noValidate
              onSubmit={handleSubmit}>
              {values.applicants.map((applicant, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.name`}
                      label="Name of Entity *"
                      placeholder="Enter Name of Entity"
                      disabled={applicant.dataFetchedFromKRA || false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label={'Date of Registration/Incorporation *'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'DD/MM/YYYY'}
                      name={`applicants.${index}.dateOfBirth`}
                      disabled={applicant.dataFetchedFromKRA || false}
                      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.cityOfIncorporation`}
                      label="Place of Registration/Incorporation *"
                      placeholder="Enter Place of Registration/Incorporation"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.ckycNo`}
                      label="CKYC No./CKYC Acknowledge No./KIN No "
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFSelectField
                      name={`applicants.${index}.investorType`}
                      label="Investor Type *"
                      items={Object.keys(investorTypeMasters).map((investor) => ({
                        key: investorTypeMasters[investor],
                        value: investor,
                      }))}
                    />
                  </Grid>
                  {/* {ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[values?.applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.boiOrAop`}
                        label="AOP or BOI *"
                        items={Object.keys(AOI_BOI_MASTER).map((investor) => ({
                          key: AOI_BOI_MASTER[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )} */}
                  {isInvestorTrust(applicant?.investorType || '') && (
                    <Grid
                      item
                      sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                        mt: { xs: 0, sm: 5 },
                        mb: { xs: 1, sm: 0 },
                      }}>
                      <MFCheckbox name={`applicants.${index}.isNPO`} label="NPO" />
                    </Grid>
                  )}
                  {applicant?.investorType && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.investorTypeCategory`}
                        label="Please select category for your organisation: *"
                        items={Object.keys(investorTypeCategoryMaster).map((investor) => ({
                          key: investorTypeCategoryMaster[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )}
                  {applicant?.investorTypeCategory &&
                    isInvestorCategorySelected(applicant?.investorTypeCategory || '') && (
                      <Grid item xs={12} sm={6}>
                        <MFSelectField
                          name={`applicants.${index}.investorTypeSubCategory`}
                          label="Commitment Amount Range *"
                          items={Object.keys(investorTypeSubCategoryMaster).map(
                            (investorcategory) => ({
                              key: investorTypeSubCategoryMaster[investorcategory],
                              value: investorcategory,
                            })
                          )}
                        />
                      </Grid>
                    )}
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.panNo`}
                      label="PAN *"
                      placeholder="Enter PAN"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <UseRadioGroup
                      name={`applicants.${index}.isAccreditedInvestor`}
                      formLabel="Accredited Investor *"
                      items={[
                        { label: YES_NO_MASTER.yes, value: true },
                        { label: YES_NO_MASTER.no, value: false },
                      ]}
                      disabled={isFieldDisabled}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const stringValue = event.target.value;
                        const boolValue = stringValue === 'true';
                        const currentValue = values.applicants[index]?.isAccreditedInvestor ?? null;
                        if (currentValue === boolValue) {
                          return;
                        }
                        const hasPlanDetails =
                          !!application?.schemeId ||
                          !!application?.planId ||
                          !!application?.commitmentAmount ||
                          !!application?.contributionChequeAmount;
                        if (hasPlanDetails) {
                          setAccreditedInvestorDialog({ newValue: boolValue });
                        } else {
                          setFieldValue(`applicants.${index}.isAccreditedInvestor`, boolValue);
                        }
                      }}
                    />
                  </Grid>
                  {values.applicants[index]?.isAccreditedInvestor === true && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.accreditationCertificateNumber`}
                          label="Accreditation Certificate Number *"
                          placeholder="Enter Certificate Number"
                          inputProps={{ maxLength: 12 }}
                          disabled={isFieldDisabled}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label="Accreditation Certificate Start Date *"
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidFrom`}
                          disabled={isFieldDisabled}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label="Accreditation Certificate End Date *"
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidTo`}
                          maxDate={null}
                          disabled={isFieldDisabled}
                        />
                      </Grid>
                    </>
                  )}
                  <SubHeading
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                    Other Details
                  </SubHeading>
                  <Grid item xs={12} sm={6}>
                    <MFSelectField
                      name={`applicants.${index}.grossAnnualIncome`}
                      label="Gross Annual Income *"
                      items={grossAnnualMasters.map((grossIncome) => ({
                        key: grossIncome,
                        value: grossIncome,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.netWorth`}
                      label="Net Worth"
                      placeholder="Enter Net Worth"
                    />
                    {values.applicants[index].netWorth &&
                      !isNaN(Number(values.applicants[index].netWorth)) && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.applicants[index].netWorth)}
                        </Typography>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label={'Net worth as on'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'Enter Net worth as on'}
                      name={`applicants.${index}.netWorthDate`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MFSelectField
                      name={`applicants.${index}.politicallyExposedPersonStatus`}
                      label="Politically Exposed Person (PEP) Status"
                      items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                      disabled={true}
                    />
                  </Grid>
                  <DematDetails
                    values={values}
                    index={index}
                    brokers={brokerList?.broker_list as Broker[]}
                    disabled={false}
                  />
                </React.Fragment>
              ))}
              <ConfirmationDialog
                message={`Plans you have selected will be removed as you have Changed Accredited Investor. Are you Sure you want to Proceed`}
                open={accreditedInvestorDialog !== null}
                setOpen={() => setAccreditedInvestorDialog(null)}
                onSave={() => {
                  if (accreditedInvestorDialog) {
                    setFieldValue(
                      `applicants.0.isAccreditedInvestor`,
                      accreditedInvestorDialog.newValue
                    );
                    setFieldValue('shouldClearPlan', true);
                  }
                  setAccreditedInvestorDialog(null);
                }}
                onCancel={() => {
                  setAccreditedInvestorDialog(null);
                }}
              />
              <ProceedSaveLater
                saveLater={() => {
                  setValues({
                    ...values,
                    applicants: values.applicants.map((applicant) => ({
                      ...applicant,
                    })),
                    saveType: 'save for later',
                  });
                }}
                saveAndProceed={() => {
                  setValues({
                    ...values,
                    applicants: values.applicants.map((applicant) => ({
                      ...applicant,
                    })),
                    saveType: 'save and proceed',
                  });
                }}
                loader={loading}
                clickedButton={values.saveType}
              />
            </Grid>
          </>
        );
      }}
    </Formik>
  );
}
